import React, { useRef, useEffect, useState } from 'react';
import Head from '../Menu/header';
import ToolBar from '../toolbar';
import Sticky from 'react-stickynode';
import styles from './Header.module.scss';
import { useMediaQuery } from "react-responsive";
import navItems from '../Menu/navItems'


function Header({ destination }) {
  const [isMounted, setIsMounted] = useState(false);
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1250px)" })
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const largeScreenHeader = (
    <Sticky innerZ={1000}>
      <div className={styles.header}>
        <ToolBar navItems={navItems} logo={destination.logo} destinationUrl={destination.url} destinationName={destination.name} />
        <Head navItems={navItems} />
      </div>
    </Sticky>
  );

  const mediumScreenHeader = (
    <div className={styles.header}>
      <ToolBar navItems={navItems} destinationUrl={destination.url} destinationName={destination.name} />
      <Sticky innerZ={1000}>
        <Head navItems={navItems} />
      </Sticky>
    </div>
  );

  return (
    <header >
      {!isMounted
        ? largeScreenHeader
        : (isTabletOrMobile ? mediumScreenHeader : largeScreenHeader)
      }
    </header>
  )
}

export default Header
